import { createApp } from 'vue';
import App from './app/App.vue';
import { installSystemKeyboard } from './services/systemKeyboard';
import './styles/base.css';
import './styles/random-products-cms.css';
import './styles/google-auth.css';
import './styles/service-modal.css';
import './styles/partner-finance.css';
import './styles/bank-connection.css';
import './styles/admin-reference.css';
import './styles/cms-order-map.css';
import './styles/cms-order-controls.css';
import './styles/order-table-enhancements.css';

createApp(App).mount('#app');
installSystemKeyboard();
